export const ENVIRONMENT = process.env.NODE_ENV || "development";
export const IS_AUTH_TOKEN_NEEDED =
  process.env.NEXT_PUBLIC_IS_AUTH_TOKEN_NEEDED;
export const IMAGE_BASE_PATH = "/quick-quote";
export const X_API_KEY = process.env.NEXT_PUBLIC_X_API_KEY;
export const NODE_ENV = process.env.NEXT_PUBLIC_NODE_ENV;
export const basePath = "/quick-quote";
export const CAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_SITE_KEY;
export const CAPTCHA_SECRET_KEY = process.env.NEXT_PUBLIC_SECRET_KEY;
export const CAPTCHA_HMAC_SECRET_KEY = process.env.NEXT_PUBLIC_HMAC_SECRET_KEY;
export const QUICK_QUOTE_REDIRECTION =
  process.env.NEXT_PUBLIC_QUICK_QUOTE_REDIRECTION;
export const API_BASE_QUICK_QUOTE =
  process.env.NEXT_PUBLIC_API_BASE_QUICK_QUOTE || "http://localhost:3005";
export const X_API_KEY_QUICK_QUOTE =
  process.env.NEXT_PUBLIC_X_API_KEY_QUICK_QUOTE;
export const ENABLED_PRODUCTS = process.env.NEXT_PUBLIC_ENABLED_PRODUCTS || [];
export const PRODUCER_CODE_HARDCODE = process.env.NEXT_PUBLIC_PRODUCER_CODE;
export const KYC_SERVICE_ID = process.env.NEXT_PUBLIC_KYC_SERVICE_ID;
export const KYC_SECRET_KEY = process.env.NEXT_PUBLIC_KYC_SECRET_KEY || "";
export const KYC_ENCRYPTION_KEY = process.env.NEXT_PUBLIC_KYC_ENCRYPTION_KEY;
export const KYC_IFRAME_URL = process.env.NEXT_PUBLIC_KYC_IFRAME_URL;
export const POLICYBAZAR_PRODUCER_CODE =
  process.env.NEXT_PUBLIC_POLICYBAZAR_PRODUCER_CODE || "";
